// Module
var code = "<h2 id=\"still-have-questions-about-your-loans\">Still Have Questions About Your Loans?</h2> <p>If you have questions or need more information, please contact us. </p> ";
// Exports
export default code;